export default __webpack_public_path__ + "static/media/Icon_awesome_arrow_alt_circle_right.2bacf1ee.svg";